import { useHealth } from '@/hooks/useHealth'
import { SessionTimer } from '@/components/session/SessionTimer'
import { SessionGeoInfo } from '@/components/session/SessionGeoInfo'

function Dot({ ok }: { ok?: boolean }) {
  const color = ok === undefined ? 'bg-muted' : ok ? 'bg-emerald-500' : 'bg-red-500'
  return <span className={`inline-block h-2.5 w-2.5 rounded-full ${color}`} />
}

export default function AppFooter() {
  const { data } = useHealth(10000)

  // 2-container architecture indicators:
  // - Backend: Overall backend health (lineage-backend monolith)
  // - DB: Database connection status (Azure PostgreSQL)
  const backendOk = data.ok
  const dbOk = data.users?.db_ok ?? false

  return (
    <footer className="sticky bottom-0 z-10 flex h-7 shrink-0 items-center justify-between border-t px-4 text-xs text-muted-foreground bg-background">
      <div className="flex items-center gap-2">
        <span className="flex items-center gap-1" title="Backend API status (lineage-backend)">
          Backend <Dot ok={backendOk} />
        </span>
        <span className="text-xs opacity-50">|</span>
        <span className="flex items-center gap-1" title="Database connection (Azure PostgreSQL)">
          DB <Dot ok={dbOk} />
        </span>
      </div>
      <div className="flex items-center gap-3">
        {/* PROJ-060: Session geolocation info (IP + country flag) */}
        <SessionGeoInfo />
        <span className="text-xs opacity-30">|</span>
        <SessionTimer />
      </div>
    </footer>
  )
}
